import React, { Component, useEffect, useState } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
//import Sidebar from "react-sidebar";
import Navbar from "./components/navbar/Navbar";
import Stackedcolumnchart from "./components/chart/stackedcolumn";
import auth from "./services/authService";
//import NavBar from "./components/menu/navBarF";
import NotFound from "./components/notFound";
import LoginForm from "./components/session/loginForm";
import Logout from "./components/session/logout";
import ProtectedRoute from "./components/common/protectedRoute";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { getMemulist } from "./services/hrm";
//import SideNavBar from "./components/menu/sideBarF";
import Search from "./components/search/search";

// import {getPrivilege} from './services/wms';
import PClist from "./components/pccheck/pclist"
import PClistnps from "./components/pccheck/pclistnps"
import BranchContext from "./components/context/branch";
import PrivilegeContext from "./components/context/privilege";
import UserContext from "./components/context/user";

import Employee from "./components/face/employee";
import Facedevice from "./components/face/device";
import LPR from "./components/lpr/lprlist";
import Truckscale from "./components/truckscale/truckredirect";
import Facemanage from "./components/face/facemanage";
import DeviceClone from "./components/face/deviceclone";
import FaceList from "./components/face/facelist";
import UserOndevice from "./components/face/userondevice";
import Faceinoutbyemp from "./components/face/cockinout";
import RegisterUser from "./components/register/registerprofile";
import Reportfacescan from "./components/face/reportfacescan";
import Dashboard from "./components/dashboard/reportfacescan";
import DashboardPC from "./components/dashboard/reportpclist";
import DashboardNPS from "./components/dashboard/reportpclistnps";
import Livecamera from "./components/face/livecamera";
import Carpark from "./components/carpark/carparkpay";
import Bookinglist from "./components/carpark/bookinglist";
import Sliplsit from "./components/carpark/sliplist";
import Resignlist from "./components/carpark/resinglist";
import Waitpaylist from "./components/carpark/waitpaylist";
import Managercarpark from "./components/carpark/managecarpark";
import Truckdetail from './components/truckscale/truckdetail'
import CCTV from './components/cctv/cctvmain';
import Faceevent from "./components/event/faceevent";
import reportpbx from "./components/PABX/reportpbx";
import Macbookregist from "./components/pccheck/macbookregis";
import Ideltimeout from "./components/common/idleTimout"
import { useHistory } from "react-router-dom";
function App() {
  const [user, setuser] = useState("");
  const [currentBranch, setcurrentBranch] = useState({ _id: "", name: "" });
  const [sidebarOpen, setsidebarOpen] = useState(false);
  const history = useHistory();
  const [menuItems, setmenuItems] = useState([]);

  const [privilege, setprivilege] = useState([]);
  // const { height, width, small } = useWindowDimensions();
  useEffect(() => {
    const loadCurrentBranch = async () => {
      setcurrentBranch(auth.getCurrentBranch);
    };
    loadCurrentBranch();
  }, []);

  useEffect(() => {
    const loadUser = async () => {
      setuser(auth.getCurrentUser);
    };
    loadUser();
  }, []);

  const handelSelectedBranch = (brandid) => {
    setcurrentBranch(brandid);
  };
  const handelOnChange = (event) => {
    setprivilege(event);
  };

  const onLoadMenuList = (event) => {};
  const toggleSideBar = () => {
    setsidebarOpen(!sidebarOpen);
  };
  const itemClick = (event) => {
    setmenuItems(event);
  };

  useEffect(() => {
    if (!user) return;
    if (!currentBranch) return;
    const loadMenulist = async () => {
      try {
        const { data: result } = await getMemulist(currentBranch._id);

        if (result.status === "success") {
          setmenuItems(result.data.menuItems);
        } else if (result.status === "error") {
          const urlGoBack = "logout";
          setTimeout(history.replace(urlGoBack), 1000);
        }
      } catch (error) {
        const urlGoBack = "logout";
        setTimeout(history.replace(urlGoBack), 1000);
      }
    };
    loadMenulist();
  }, [user, currentBranch, history]);

  //console.log(menuItems)
  if (!privilege) {
    return <div></div>;
  }

  return (
    <UserContext.Provider value={user}>
      <PrivilegeContext.Provider
        value={{ menuItems: menuItems, onChange: handelOnChange }}
      >
        <BranchContext.Provider
          value={{ currentBranch, onSelected: handelSelectedBranch }}
        >
          <React.Fragment>
            <ToastContainer />
            <Navbar
              user={user}
              menulist={onLoadMenuList}
              itemClick={itemClick}
            ></Navbar>

            <div className="container-fluid">
              <div className="row justify-content-center">
                <main
                  role="main"
                  className="container-fluid"
                  style={{
                    padding: "5px",
                    marginTop: "100px",
                    marginLeft: "5px",
                    marginRight: "5px",
                  }}
                >
                  {/* <usestatelogin/> */}
                  <Switch>
                    <ProtectedRoute path="/search" component={Search} />
                    <ProtectedRoute
                      path="/Stackedcolumnchart"
                      component={Stackedcolumnchart}
                    />
                    <ProtectedRoute path="/facedevice" component={Facedevice} />
                    <ProtectedRoute path="/truckscale" component={Truckscale} />
                    <ProtectedRoute path="/lpr" component={LPR} />
                    <ProtectedRoute path="/cctv/:id" exact render={props => <CCTV {...props}/>}/>
                    <ProtectedRoute
                      exact
                      path="/facemanage"
                      component={Facemanage}
                    />
                    <ProtectedRoute
                      exact
                      path="/facelist"
                      component={FaceList}
                    />
                    <ProtectedRoute
                      path="/userondevice/:id"
                      component={(props) => <UserOndevice {...props} />}
                    />

                    <ProtectedRoute path ="/truckdetail/:id" exact render={props => <Truckdetail {...props}/>}/> 

                    <ProtectedRoute path="/empprofile" component={Employee} />
                    <ProtectedRoute path="/faceevent" component={Faceevent} />
                    <ProtectedRoute path="/macbookregis" component={Macbookregist} />
                    <ProtectedRoute
                      path="/faceinout"
                      exact
                      render={(props) => (
                        <Faceinoutbyemp {...props} user={user} />
                      )}
                    />
                    <ProtectedRoute
                      path="/clonedevice/:id"
                      exact
                      render={(props) => <DeviceClone {...props} user={user} />}
                    />
                    <ProtectedRoute
                      path="/reportfacescan/:id"
                      component={Reportfacescan}
                    />
                    <ProtectedRoute
                      path="/liveview/:id"
                      component={Livecamera}
                    />
                    <ProtectedRoute path="/dashboard" component={Dashboard} />
                    
                    <ProtectedRoute
                      path="/carpark"
                      exact
                      render={(props) => <Carpark {...props} user={user} />}
                    />
                    <ProtectedRoute
                      path="/sliplist"
                      exact
                      render={(props) => <Sliplsit {...props} user={user} />}
                    />
                    <ProtectedRoute
                      path="/bookinglist"
                      exact
                      render={(props) => <Bookinglist {...props} user={user} />}
                    />
                   <ProtectedRoute path ="/dashboardpc" exact render={props => <DashboardPC {...props}/>}/> 
                   <ProtectedRoute path ="/dashboardnps" exact render={props => <DashboardNPS {...props}/>}/> 
                    <ProtectedRoute path="/reportpbx" component={reportpbx} />
                    <ProtectedRoute path="/pclist" component={PClist} />
                    <ProtectedRoute path="/pclist-nps" component={PClistnps} />
                    <ProtectedRoute path="/waitlist" component={Waitpaylist} />
                    <ProtectedRoute path="/resignlist" component={Resignlist} />
                    <Route path="/registeruser" component={RegisterUser} />;
                    <Redirect from="/" exact to="/search" />
                    <ProtectedRoute
                      path="/managercarpark"
                      component={Managercarpark}
                    />
                    ;
                    <Route path="/login" component={LoginForm} />;
                    <Route path="/ideltimeout" component={Ideltimeout} />;
                    
                    <ProtectedRoute path="/logout" component={Logout} />;
                    <Route path="/not-found" component={NotFound} />
                    <Redirect from="/" exact to="/search" />
                    <Redirect to="/not-found" />
                  </Switch>
                </main>
              </div>
            </div>
          </React.Fragment>
        </BranchContext.Provider>
      </PrivilegeContext.Provider>
    </UserContext.Provider>
  );
}

export default App;
